import { events } from "@photo-sphere-viewer/markers-plugin";
const iframes = new Map();
export function attachListeners(viewer, markersPlugin, getDefaultCaption) {
    markersPlugin.addEventListener("select-marker", urlOnClick);
    markersPlugin.addEventListener("select-marker", handleVideoMarker(viewer));
    markersPlugin.addEventListener("enter-marker", hoverPolylines);
    markersPlugin.addEventListener("leave-marker", hoverPolylines);
    markersPlugin.addEventListener("set-markers", () => createIframes(markersPlugin));
    markersPlugin.addEventListener("set-markers", unmuteVideos);
    markersPlugin.addEventListener("set-markers", unloopVideos(markersPlugin, viewer, getDefaultCaption));
    markersPlugin.addEventListener("set-markers", handleAutoStartVideo(viewer, getDefaultCaption));
    createIframes(markersPlugin);
}
function unmuteVideos(e) {
    e.markers.forEach(marker => {
        if (marker.config.videoLayer) {
            marker.video.muted = false;
        }
    });
}
function unloopVideos(markersPlugin, viewer, getDefaultCaption) {
    return (e) => {
        e.markers.forEach(marker => {
            if (!marker.config.videoLayer)
                return;
            const video = marker.video;
            video.loop = false;
            video.addEventListener("ended", () => {
                markersPlugin.removeMarker(marker.id);
                resetVideoTools(viewer, getDefaultCaption());
            });
        });
    };
}
function urlOnClick(e) {
    if (e.marker.data?.clickUrl) {
        window.open(e.marker.data.clickUrl, "_blank")?.focus();
    }
}
function createIframes(markersPlugin) {
    const markers = markersPlugin.getMarkers();
    const ids = markers.map(m => m.id);
    markers.forEach(marker => {
        if (marker.data?.iframe?.needsRefresh) {
            const id = marker.id;
            const config = marker.config;
            config.data.iframe.needsRefresh = false;
            const iframe = iframes.get(id) ?? document.createElement("iframe");
            iframe.src = marker.data.iframe.src;
            iframe.allowFullscreen = true;
            iframe.width = `${config.size?.width ?? 0}px`;
            iframe.height = `${config.size?.height ?? 0}px`;
            iframes.set(id, iframe);
            // delete marker if not elementLayer
            // then add a new one as elementLayer
            if (!marker.config.elementLayer) {
                markersPlugin.removeMarker(id);
                markersPlugin.addMarker({
                    ...config,
                    html: undefined,
                    elementLayer: iframe,
                });
            }
        }
    });
    // delete all iframes not used
    for (const key in iframes.keys()) {
        if (key in ids)
            continue;
        iframes.delete(key);
    }
}
let currentVideo = null;
function handleAutoStartVideo(viewer, getDefaultCaption) {
    return (e) => {
        resetVideoTools(viewer, getDefaultCaption());
        e.markers.forEach(marker => {
            if (marker.config.videoLayer && marker.config.autoplay !== false) {
                initVideoTools(viewer);
                const video = marker.video;
                if (video !== currentVideo) {
                    // prevent multiple videos playing at the same time
                    currentVideo?.pause();
                    currentVideo?.removeEventListener("timeupdate", videoBarHandler);
                }
                video.addEventListener("timeupdate", videoBarHandler);
                currentVideo = video;
            }
        });
    };
}
function handleVideoMarker(viewer) {
    return (e) => {
        if (e.marker.type === "videoLayer") {
            const video = e.marker.video;
            if (video !== currentVideo) {
                // prevent multiple videos playing at the same time
                currentVideo?.pause();
                currentVideo?.removeEventListener("timeupdate", videoBarHandler);
            }
            if (video.paused) {
                initVideoTools(viewer);
                video.addEventListener("timeupdate", videoBarHandler);
                video.play();
                currentVideo = video;
                document.getElementById("video-slider").value =
                    video.currentTime.toString();
                document.getElementById("volume-slider").value =
                    (video.volume * 100).toString();
            }
            else {
                e.marker.video.pause();
                video.removeEventListener("timeupdate", videoBarHandler);
            }
        }
    };
}
let videoToolsInit = false;
function initVideoTools(viewer) {
    if (videoToolsInit)
        return;
    viewer.navbar.setCaption(`<div class="video-controls">\
        <span id="video-time">00:00</span>
        <input type="range" min="0" max="100" value="0" id="video-slider" title="Zeit">
        <span>&#128266;</span>
        <input type="range" min=0" max="100" value="100" \
        id="volume-slider" title="Volume"></div>`);
    document.getElementById("video-slider")?.addEventListener("input", e => {
        if (!currentVideo)
            return;
        currentVideo.currentTime = currentVideo.duration * (Number(e.target.value) / 100);
    });
    document.getElementById("volume-slider")?.addEventListener("input", e => {
        if (!currentVideo)
            return;
        currentVideo.volume = Number(e.target.value) / 100;
    });
    videoToolsInit = true;
}
function resetVideoTools(viewer, defaultCaption) {
    if (!videoToolsInit)
        return;
    viewer.navbar.setCaption(defaultCaption);
    videoToolsInit = false;
}
function videoBarHandler(e) {
    const video = currentVideo;
    if (!video)
        return;
    const currentTime = Math.floor((100 / video.duration) * video.currentTime);
    document.getElementById("video-slider").value = currentTime.toString();
    document.getElementById("video-time").innerText =
        `${(video.currentTime / 60).toLocaleString(undefined, {
            minimumIntegerDigits: 2,
            maximumFractionDigits: 0,
            useGrouping: false
        })}:${(video.currentTime % 60).toLocaleString(undefined, {
            minimumIntegerDigits: 2,
            maximumFractionDigits: 0,
            useGrouping: false
        })}`;
}
function hoverPolylines(e) {
    if (!e.marker.config.polygon && !e.marker.config.polyline)
        return;
    if (!e.marker.config.hoverScale)
        return;
    if (e instanceof events.EnterMarkerEvent) {
        e.marker.domElement.classList.add("hover");
    }
    if (e instanceof events.LeaveMarkerEvent) {
        e.marker.domElement.classList.remove("hover");
    }
}
